/** Настройки сборки. Значения по умолчанию совпадают со старой версией приложения. */
export const config = {
  botLink: import.meta.env.VITE_BOT_LINK ?? "https://t.me/ContactMovies_bot/movies_app",
  channelUrl: import.meta.env.VITE_CHANNEL_URL ?? "https://t.me/",
  bannerText: import.meta.env.VITE_BANNER_TEXT ?? "🎉 Место для вашей рекламы!",
};
